import { TableRow, TableCell, Checkbox, IconButton } from "@mui/material";


import { Fragment } from "react";
import TableCelldata from "../TableCellData.jsx";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

/** Presentational section; state and actions remain owned by its parent. */
export default function ExpandableTableRow({ setting, isSelected, row, canSelect, handleClick, headers, setOpen, index, open, currentRow, rows, setAllRows, editApi, editInputApi, actions }) {
  return (
<TableRow
                            sx={{
                              "& > *": {
                                borderBottom:
                                  setting?.TableType === "accordian"
                                    ? "unset !important"
                                    : "",
                              },
                            }}
                            selected={isSelected(row)}
                            hover
                          >
                            {canSelect && (
                              <TableCell padding="checkbox">
                                <Checkbox
                                  onClick={() => handleClick(row)}
                                  checked={isSelected(row)}
                                />
                              </TableCell>
                            )}

                            {headers.map((item, i) => {
                              if (
                                row[item.name] !== undefined &&
                                item.showInList &&
                                !item.showInExtra
                              ) {
                                return (
                                  <Fragment key={i + "condi"}>
                                    <TableCell
                                      onClick={() =>
                                        setOpen({ [index]: !open[index] })
                                      }
                                      onMouseDown={() => currentRow(row)}
                                      colSpan={item.colSpan || 1}
                                    >
                                      <TableCelldata
                                        row={row}
                                        item={item}
                                        rows={rows}
                                        setAllRows={setAllRows}
                                        editApi={editApi}
                                        editInputApi={editInputApi}
                                      />
                                    </TableCell>
                                  </Fragment>
                                );
                              } else {
                                return (
                                  <Fragment key={i + "vdsvsd"}>
                                    <TableCell
                                      sx={{
                                        width: "0px !important",
                                        padding: "0px !important",
                                      }}
                                    ></TableCell>
                                  </Fragment>
                                );
                              }
                            })}
                            {actions &&
                              setting?.TableType !== "accordian" &&
                              actions?.map((action, index) => (
                                <TableCell
                                  onMouseDown={() => currentRow(row)}
                                  key={index + "actionBody"}
                                >
                                  {typeof action?.handler === "function" ? action.handler(row) : action?.handler}
                                </TableCell>
                              ))}
                            {setting?.TableType === "accordian" ? (
                              <TableCell>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={() =>
                                    setOpen({ [index]: !open[index] })
                                  }
                                  onMouseDown={() => currentRow(row)}
                                >
                                  {open[index] ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </TableCell>
                            ) : (
                              <></>
                            )}
                          </TableRow>
  );
}
